import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HighlightModule, HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import json from 'highlight.js/lib/languages/json';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ErrorComponent } from './pages/error/error.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeroComponent } from './components/hero/hero.component';
import { HomeContentComponent } from './components/home-content/home-content.component';
import { LoadingComponent } from './components/loading/loading.component';
import { ScheduleComponent } from './pages/schedule/schedule.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthHttpInterceptor, AuthModule, provideAuth0 } from '@auth0/auth0-angular';
import { environment as env } from '../environments/environment';
import {MatTableModule} from '@angular/material/table';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import { ProfileFormComponent } from './pages/profile-form/profile-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {LoginComponent} from './pages/login/login.component'
import { EmbeddedLoginComponent } from './pages/embedded-login/embedded-login.component';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { CreateEnterpriseConnectionComponent } from './pages/create-enterprise-connection/create-enterprise-connection.component';
import { ConnectionsPageComponent } from './pages/connections-page/connections-page.component';
import { OrganizationComponent } from './pages/organization/organization.component';
import { ApiKeyPageComponent } from './pages/api-key-page/api-key-page.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ProfileComponent,
    NavBarComponent,
    FooterComponent,
    HeroComponent,
    HomeContentComponent,
    LoadingComponent,
    ScheduleComponent,
    ProfileFormComponent,
    ErrorComponent,
    LoginComponent,
    EmbeddedLoginComponent,
    CreateEnterpriseConnectionComponent,
    ConnectionsPageComponent,
    OrganizationComponent,
    ApiKeyPageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    HighlightModule,
    FontAwesomeModule,
    // AuthModule.forRoot({
    //   ...env.auth,
    //   httpInterceptor: {
    //     ...env.httpInterceptor,
    //   },
      
    // }),
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatInputModule
  ],
  providers: [
    provideAuth0({
      domain: env.auth.domain,
      clientId: env.auth.clientId,
      authorizationParams: env.auth.authorizationParams,
      httpInterceptor: env.httpInterceptor
    }),
    {
      provide: Window,
      useValue: window,
    },
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        languages: {
          json: () => import('highlight.js/lib/languages/json'),
        },
      },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
